<template>
  <div class="_title">
    <slot></slot>
    <span>{{subtext}}</span>
  </div>
</template>

<script>
export default {
  props: {
    subtext: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
._title {
  color: $white;
  background-color: #000;
  font-size: 16px;
  padding: 10px 0 10px 30px;
  span {
    font-size: 13px;
    margin-left: 10px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  ._title {
    padding-left: 20px;
  }
}
</style>
